import { ReactNode } from 'react'
import { useHistory } from 'react-router-dom'

import { Button, Card, Icon } from 'common/components'

import './styles.less'

interface NavigationProps {
  children: ReactNode
  title: string | ReactNode
  redirectPath: string
  disclaimerModal?: () => void
  actions?: React.ReactNode[]
}

const Navigation = ({ children, title, redirectPath, disclaimerModal, actions }: NavigationProps) => {
  const history = useHistory()

  return (
    <Card
      title={
        <>
          <Button
            type="default"
            size="small"
            onClick={() => {
              if (disclaimerModal) {
                disclaimerModal()
              } else {
                history.push(redirectPath)
              }
            }}
          >
            <Icon type="fa fa-arrow-left" fontAwesome />
          </Button>
          {typeof title === 'string' ? <h5 className="request_for_reimburse_title pl-8">{title}</h5> : title}
        </>
      }
      actions={actions}
      className="request_for_reimburse_card"
    >
      {children}
    </Card>
  )
}

export default Navigation
